import React, { useState } from 'react'
import PluginModal from "../../modals/plugin-modal/PluginModal";
import { useNavigate } from "react-router-dom";

export default function PluginsView() {

    const [selectedPlugin, setSelectedPlugin] = useState(null);
    const navigate = useNavigate();

    const plugins = [
        { id: "echomail", name: "EchoMail", description: "Send bulk emails with ease" },
        // more placeholders...
    ];

    return (
        <div style={{ padding: "16px" }}>
            <h2>Plugins</h2>
            <ul>
                {plugins.map((p) => (
                    <li
                        key={p.id}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            if (p.id === "echomail") {
                                navigate("/plugins/echomail");
                            } else {
                                setSelectedPlugin(p);
                            }
                        }}
                    >
                        {p.name}
                    </li>
                ))}
            </ul>

            {selectedPlugin && (
                <PluginModal
                    plugin={selectedPlugin}
                    onClose={() => setSelectedPlugin(null)}
                />
            )}
        </div>
    );
}